import Link from "next/link";
import type * as CSS from "csstype";
import { COLORS } from "./styles";

const styles: { [key: string]: CSS.Properties } = {
  link: {
    color: COLORS.primaryHue,
  },
};

export default function XLink(props: {
  href: string;
  children: React.ReactNode;
  target?: "_blank";
}) {
  return (
    <Link style={styles.link} href={props.href} target={props.target}>
      {props.children}
    </Link>
  );
}
